/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_First_TitleInputs */

const en_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First event`)
};

const fr_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premier evenement`)
};

const de_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Veranstaltung`)
};

const it_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primo evento`)
};

const ru_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первое событие`)
};

const es_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primer evento`)
};

const zh_cn2_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首场活动`)
};

const ja_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のイベント`)
};

const hi_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहला आयोजन`)
};

const pt_pt2_image_export_preview_first_title = /** @type {(inputs: Image_Export_Preview_First_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiro evento`)
};

/**
* | output |
* | --- |
* | "First event" |
*
* @param {Image_Export_Preview_First_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_first_title = /** @type {((inputs?: Image_Export_Preview_First_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_First_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_first_title(inputs)
	if (locale === "de") return de_image_export_preview_first_title(inputs)
	if (locale === "it") return it_image_export_preview_first_title(inputs)
	if (locale === "ru") return ru_image_export_preview_first_title(inputs)
	if (locale === "es") return es_image_export_preview_first_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_first_title(inputs)
	if (locale === "ja") return ja_image_export_preview_first_title(inputs)
	if (locale === "hi") return hi_image_export_preview_first_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_first_title(inputs)
	return en_image_export_preview_first_title(inputs)
});